import { FaGithub, FaLinkedin, FaFigma } from "react-icons/fa"; 

const SocialMediaIcons = () => {
    return (
      <div className="flex justify-center md:justify-start my-10 gap-7">
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://www.linkedin.com/in/johanna-fogel-47209670/"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedin size={32} />
        </a>
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://github.com/Vitoleander"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub size={32} />
        </a>
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://www.figma.com/files/recent?fuid=1071378331428294225"
          target="_blank"
          rel="noreferrer"
        >
          <FaFigma size={32} />
        </a>
      </div>
    );
  };
  
  export default SocialMediaIcons;